(function($) {
    
    const customFileInput = document.querySelectorAll('.custom-file-input')
    
    if(customFileInput) {
        
        customFileInput.forEach(el => {
            const input = el.querySelector('input[type="file"]')
            const button = el.querySelector('.file-button')
            const content = el.querySelector('.file-content')
            const text = el.querySelector('.file-name')
            const defaultText = text.innerText
            
            const form = el.closest('form')
            
            const clearInput = document.createElement('button')
            clearInput.classList.add('remove-file')
            clearInput.innerHTML = "Remover"
            clearInput.type = 'button'
            
            input.setAttribute('tabindex', '-1')
            
            button.addEventListener('click', () => input.click())
            
            function clear() {
                input.value = ''
                text.innerHTML = defaultText ? defaultText : 'Nenhum arquivo selecionado'
                
                clearInput.remove()
            }
            
            form.addEventListener('wpcf7invalid', event => {
                const fieldName = input.name
                const fieldError = 
                    event && event.detail && event.detail.apiResponse && event.detail.apiResponse.invalid_fields
                    ? event.detail.apiResponse.invalid_fields.find(el => el.field === fieldName)
                    : null
                
                if(fieldError) {
                    alert(`Erro ao enviar arquivo: ${fieldError.message}`)
                }
            })
            
            form.addEventListener('wpcf7mailsent', () => clear())
            clearInput.addEventListener('click', () => clear())
            
            input.addEventListener('change', function() {
                if(this.files.length) {
                    const textValue = this.files.length > 1 
                        ? `${this.files.length} arquivos escolhidos` 
                        : this.files[0].name
                        
                    text.innerHTML = textValue
                    content.appendChild(clearInput)
                        
                    return
                }
                
                clear()
            })
        })
    }

})(jQuery);